const slides = [
  {
    id: '1',
    question: `Rumor has it there's a magical snowman spreading cheer around town,
      and you've got to see for yourself.
      <br/><br/>
      Who are you hoping to run into?`,
    leadText:'likes',
    answers: [
      {
        text: 'Classic Frosty',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Frozen\'s Olaf',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '2',
    question: `A blizzard blew in last night, there's snow up to the window panes, and you've got the day off.
      <br/><br/>
      How will you spend your day?`,
    leadText:'would rather',
    answers: [
      {
        text: 'Go sledding',
        scratcher: 'festive-50',
      },
      {
        text: 'Cozy up by the fire',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '3',
    question: `Your mom volunteered you to play one of Santa's reindeer in the
      local Christmas play, and there are only two spots left.
      <br/><br/>
      Who do you pick?`,
    leadText:'wants to be',
    answers: [
      {
        text: 'Dancer',
        scratcher: 'raffle',
      },
      {
        text: 'Prancer',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '4',
    question: `Tis the season for beverages you'd probably be judged for drinking
      any other time of year.
      <br/><br/>
      What's your go-to holiday party drink?`,
    leadText: 'prefers',
    answers: [
      {
        text: 'Eggnog',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Hot Chocolate',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '5',
    question: `It's unavoidable; Christmas music is playing everywhere you go.
      <br/><br/>
      Which song is more likely to get stuck in your head for days on end?`,
    leadText:'sings',
    answers: [
      {
        text: 'Jingle Bells',
        scratcher: 'festive-50',
      },
      {
        text: 'Deck the Halls',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '6',
    question: `It's your first holiday party at your brand new job, and you haven't
      quite gotten a sense of the company vibe.
      <br/><br/>
      Which do you wear?`,
    leadText:'wears a',
    answers: [
      {
        text: 'Tacky Sweater',
        scratcher: 'raffle',
      },
      {
        text: 'Turtleneck',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '7',
    question: `Don't forget that St. Nick has had his eye on you. All. Year. Long.
      <br/><br/>
      Which of Santa's lists are you more likely to be on this year?`,
    leadText:'is',
    answers: [
      {
        text: 'Naughty',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Nice',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '8',
    question: `You're the first to wake up on Christmas morning and decide to
      get a head start on opening presents.
      <br/><br/>
      Which do you reach for first?`,
    leadText:'wants a',
    answers: [
      {
        text: 'Small Gift Bag',
        scratcher: 'festive-50',
      },
      {
        text: 'Large Gift Box',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '9',
    question: `It's an age-old debate at Christmas time, but there's a right answer, isn't there?
      <br/><br/>
      What kind of tree will you be trimming this year?`,
    leadText:'has a',
    answers: [
      {
        text: 'Artificial Tree',
        scratcher: 'raffle',
      },
      {
        text: 'Real Tree',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '10',
    question: `You’ve got a busy day ahead of you...but the snow doesn't look like it’s stopping anytime soon.
      <br/><br/>
      What are you hoping for in the morning?`,
    leadText:'prefers',
    answers: [
      {
        text: 'Snow Day',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Clear Salted Roads',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '11',
    question: `You and your significant other have a moment to yourselves to enjoy,
      away from friends and family.
      <br/><br/>
      How will you make it a memorable one?`,
    leadText:'is happiest with',
    answers: [
      {
        text: 'Mistletoe',
        scratcher: 'festive-50',
      },
      {
        text: 'Snowball Fight',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '12',
    question: `According to the old adage, "It's better to give than to receive,"
      but we won't judge if you feel differently.
      <br/><br/>
      Which makes you happier?`,
    leadText:'is happiest when',
    answers: [
      {
        text: 'Getting Gifts',
        scratcher: 'raffle',
      },
      {
        text: 'Giving Gifts',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '13',
    question: `You went for store-bought this year instead of your famous homemade
      dessert.
      <br/><br/>
      Which candle do you light to keep the family from finding out?`,
    leadText:'likes the smell of',
    answers: [
      {
        text: 'Cinnamon',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Vanilla',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '14',
    question: `You've had your fill at your family's Christmas feast, but there's
      always room for dessert.
      <br/><br/>
      Which festive treat satisfies your sweet tooth?`,
    leadText: 'fills up on',
    answers: [
      {
        text: 'Candy Canes',
        scratcher: 'festive-50',
      },
      {
        text: 'Gingerbread Man',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '15',
    question: `Your friends are in a heated argument and ask you to help settle the debate:
      <br/><br/>
      Which Macaulay Culkin classic is the better Christmas movie?`,
    leadText:'prefers',
    answers: [
      {
        text: 'Home Alone 1',
        scratcher: 'raffle',
      },
      {
        text: 'Home Alone 2 - Lost in NY',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '16',
    question: `You've been sent to pick up Christmas lights to decorate your
      parents' house, but can't remember their preference.
      <br/><br/>
      Which do you go with?`,
    leadText:'decorates with',
    answers: [
      {
        text: 'Colored Lights',
        scratcher: 'holiday-riches',
      },
      {
        text: 'White Lights',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '17',
    question: `You're in charge of this year's holiday party playlist and know
      the music you choose will set the tone for the evening.
      <br/><br/>
      Where do you start?`,
    leadText:'listens to',
    answers: [
      {
        text: 'Frank Sinatra',
        scratcher: 'festive-50',
      },
      {
        text: 'Mariah Carey',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '18',
    question: `Your adrenaline-junkie friend has convinced you to take on a black diamond hill.
      <br/><br/>
      What sounds like the least terrifying way to get down?`,
    leadText:'would rather go',
    answers: [
      {
        text: 'Skiing',
        scratcher: 'raffle',
      },
      {
        text: 'Snowboarding',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '19',
    question: `Your neighbor has organized a sledding competition down the biggest hill in town.
      <br/><br/>
      What kind of sled do you grab to ensure victory?`,
    leadText:'sleds with a',
    answers: [
      {
        text: 'Plastic Disc',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Metal Sled',
        scratcher: 'seasons-winnings',
      },
    ],
  },
  {
    id: '20',
    question: `It's always been the family tradition to watch a movie together
      on Christmas, and you get to choose this year.
      <br/><br/>
      What's your pick?`,
    leadText:'loves',
    answers: [
      {
        text: 'A Christmas Story',
        scratcher: 'festive-50',
      },
      {
        text: 'Christmas Vacation',
        scratcher: 'sneak-a-peak',
      },
    ],
  },
  {
    id: '21',
    question: `Everybody has that one relative who is notorious for giving bad gifts.
      <br/><br/>
      If you had a say over what they got you, which would you choose?`,
    leadText:'would rather get',
    answers: [
      {
        text: 'Socks',
        scratcher: 'raffle',
      },
      {
        text: 'Bunny Pajamas',
        scratcher: 'tacky-sweater',
      },
    ],
  },
  {
    id: '22',
    question: `You've been procrastinating, and now you're almost out of time to buy presents.
      <br/><br/>
      What are you more likely to get for your loved ones?` ,
    leadText: 'likes to give',
    answers: [
      {
        text: 'Gift Cards',
        scratcher: 'holiday-riches',
      },
      {
        text: 'Gift',
        scratcher: 'seasons-winnings',
      },
    ],
  },
]

export default slides;



/** WEBPACK FOOTER **
 ** ./src/slides.js
 **/